import { RemoteGetAllPerson } from 'data/usecases';
import { GetAllPersonUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPerson = (): GetAllPersonUseCaseInterface =>
  new RemoteGetAllPerson(makeApiUrlPerson(), makeAxiosHttpClient());
